import { render, staticRenderFns } from "./TheMobileAppsNotice.vue?vue&type=template&id=06ca6e6a&scoped=true&lang=pug&"
import script from "./TheMobileAppsNotice.vue?vue&type=script&lang=js&"
export * from "./TheMobileAppsNotice.vue?vue&type=script&lang=js&"
import style0 from "./TheMobileAppsNotice.vue?vue&type=style&index=0&id=06ca6e6a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca6e6a",
  null
  
)

export default component.exports